import Link from 'next/link'
import { useRouter } from 'next/router'

export const PdContactUsBanner = () => {
  const router = useRouter()
  let { source } = router.query as { source: string }

  // 没有source,表示不是广告跳转过来的，这里直接隐藏
  if (!source) {
    return null
  }

  return (
    <Link href={'/contact-us?source=' + source}>
      <div className="fixed bottom-0 left-0 right-0 w-full bg-pdblue text-center laptop:py-22px py-11px text-white cursor-pointer group overflow-hidden  text-sm laptop:text-lg">
        {/* light background */}
        <div className="animate-scroll-x h-full">
          <div className="w-170px h-fit relative">
            <div className="w-8 min-h-68px left-0 top-7 absolute origin-top-left rotate-[30deg] opacity-50 bg-white blur-[46px]" />
          </div>
        </div>

        {/* content bar */}
        <p className="flex justify-center items-center pointer px-0">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M5 17.9245H7.33333C7.88562 17.9245 8.33333 18.3722 8.33333 18.9245V21.1594C8.33333 21.4413 8.68704 21.5675 8.86555 21.3493L11.3666 18.2914C11.5565 18.0592 11.8407 17.9245 12.1406 17.9245H19C20.1046 17.9245 21 17.0291 21 15.9245V6C21 4.89543 20.1046 4 19 4H5C3.89543 4 3 4.89543 3 6V15.9245C3 17.0291 3.89543 17.9245 5 17.9245Z"
              fill="#5297FF"
              stroke="white"
            />
            <path d="M9 12C10 13 12.6 14.4 15 12" stroke="white" strokeLinecap="round" />
          </svg>
          <span className="laptop:ml-2 ml-1 laptop:mr-2 mr-1">
            If you&apos;re interested, please feel free to contact us
          </span>
          <span className="group-hover:laptop:translate-x-6 ease-in-out duration-300">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M20.6417 11.2645L5.44479 3.7175C4.78005 3.38738 4 3.87094 4 4.61314V8.89523C4 9.33663 4.2894 9.72582 4.71212 9.85289L9.67799 11.3456C9.77323 11.3743 9.77283 11.5093 9.67742 11.5373L4.71776 12.9965C4.29221 13.1217 4 13.5123 4 13.9558V18.3771C4 19.1216 4.78457 19.6051 5.44963 19.2703L20.6427 11.6223C20.7899 11.5482 20.7894 11.3378 20.6417 11.2645Z"
                stroke="white"
              />
            </svg>
          </span>
        </p>
      </div>
    </Link>
  )
}
